module.exports = __webpack_public_path__ + "static/media/winky-life.49a4fc54.svg";